import Swiper from 'swiper/bundle';

if ($('.js-sliderProjects').length > 0) {
  let ww = $(window).width();

  $(window).on('load', function() {
    if (ww < 768) {
      let sliderProjects = new Swiper('.js-sliderProjects .swiper-container', {
        slidesPerView: "auto",
        // spaceBetween: 16,
        // slidesOffsetAfter: 16,
        // slidesOffsetBefore: 16,
        pagination: {
          el: '.js-sliderProjects .swiper-pagination',
          type: 'bullets',
          clickable: true
        },
      });
    }
  });
}